import styled from 'styled-components';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
export const ModalMessageBox = styled(MessageBox) `
  width: calc(100% - 59px);
  height: fit-content;
`;
